import script from "./ROC.vue?vue&type=script&lang=js"
export * from "./ROC.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__